import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SeaculumAngularFormlyService } from '../../services/saeculum-angular-formly.service';
import { INFO_ICON } from '../../constant/common.constant';
import { FormBaseClass } from '../shared/base-class/form-base-class';
@Component({
    selector: 'saeculum-input-textbox',
    templateUrl: './textbox.component.html',
    styleUrls: ['./textbox.component.scss'],
})
export class TextboxComponent extends FormBaseClass implements OnInit, OnChanges {
    @Input() fieldObj: any;
    @Input() options;
    @Input() values;
    @Input() form: FormGroup;
    @Input() type = '';
    @Output() valueChange = new EventEmitter<any>();
    infoIcon = INFO_ICON.icon;
    inputType: any = 'text';

    constructor(public formService: SeaculumAngularFormlyService) {
        super();
    }

    ngOnInit() {
        this.addControl();
    }

    addControl() {
        this.form.addControl(this.fieldObj.key, new FormControl(this.values ? this.values[this.fieldObj.key] : null));
        this.inputType = this.fieldObj.type;
        this.setValidations(this.form, this.fieldObj);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.values && changes.values.currentValue && this.form.get(this.fieldObj.key)) {
            this.form.get(this.fieldObj.key).setValue(changes.values.currentValue);
        }
    }

    notifyChange(event) {
        this.valueChange.emit({ key: this.fieldObj.key, value: this.form.get(this.fieldObj.key).value });
    }

    showPasswordClick() {
        this.inputType = this.inputType === 'text' ? 'password' : 'text';
    }

}

